import React from "react";
import PropTypes from "prop-types";

// mui
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import IconButton from "@mui/material/IconButton";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { styled } from "@material-ui/styles";
import Chip from "@mui/material/Chip";

// config
import { OCR_RESULT_STATUS } from "../../../../Config";

const StyledSuccessChip = styled(Chip)(({ theme }) => ({
  "&.MuiChip-root": {
    height: "28px",
    backgroundColor: "#F2FCF1",
    color: "#fff",
    padding: "0px 4px 0px 4px",
    "& .MuiChip-icon": {
      color: "#3FB433",
    },
    "& .MuiChip-label": {
      paddingLeft: "0",
    },
  },
}));

const StyledFailedChip = styled(Chip)(({ theme }) => ({
  "&.MuiChip-root": {
    height: "28px",
    backgroundColor: "#FFF1F1",
    color: "#fff",
    padding: "0px 4px 0px 4px",
    "& .MuiChip-icon": {
      color: "#F83B3B",
    },
    "& .MuiChip-label": {
      paddingLeft: "0",
    },
  },
}));

const CustomMenuItem = ({ imgObj, handleDelete }) => (
  <>
    {OCR_RESULT_STATUS in imgObj && imgObj[OCR_RESULT_STATUS] ? (
      <StyledSuccessChip icon={<CheckRoundedIcon fontSize="small" />} />
    ) : (
      <>
        {OCR_RESULT_STATUS in imgObj && !imgObj[OCR_RESULT_STATUS] && (
          <StyledFailedChip icon={<WarningRoundedIcon fontSize="small" />} />
        )}

        <IconButton onClick={() => handleDelete(imgObj)}>
          <ClearRoundedIcon fontSize="small" />
        </IconButton>
      </>
    )}
  </>
);

CustomMenuItem.propTypes = {
  imgObj: PropTypes.object,
  handleDelete: PropTypes.func,
};

CustomMenuItem.defaultProps = {
  imgObj: {},
  handleDelete: () => null,
};

export default CustomMenuItem;
